import { routeOptionsFor, routeOptionsForMany, routeOptionLabel } from './archiveLore.js';

// ─── This thread's route (2026-10-12) ────────────────────────────────────────
// A thread that continues one played route names it; that room alone feeds the
// archive for the thread and the model is told it is the truth over any other
// route. Every room the character was played in is offered, AU rooms included
// and labeled, because the writers decide what a thread continues (Haley chose
// #alistair-reboot2, filed as AU by the map, for the Alistair thread).
// Saved as story_preferences.canon_route ('' = the map's canon routes).
export default function ThreadRouteSelect({ characterId = null, characterIds = null, value, onChange, selectStyle, hintStyle }) {
  const options = Array.isArray(characterIds) && characterIds.length ? routeOptionsForMany(characterIds) : routeOptionsFor(characterId);
  if (!options.length) return null;
  const current = typeof value === 'string' ? value : '';
  const known = options.some(o => o.channel === current);
  return (
    <>
      <select style={selectStyle} value={current} onChange={e => onChange(e.target.value)} aria-label="This thread's route">
        <option value="">All canon routes (the map decides)</option>
        {!known && current ? <option value={current}>#{current}</option> : null}
        {options.map(o => <option key={o.channel} value={o.channel}>{routeOptionLabel(o)}</option>)}
      </select>
      <div style={hintStyle}>
        Pick the played route this thread continues. Only that room feeds the archive here, and the character treats it as the truth over any other route.
      </div>
    </>
  );
}
